export default __webpack_public_path__ + "static/media/info-grey.2fec63bb.svg";